import style from './TopContainer.module.css';

interface Props {
  children: React.ReactNode;
}

export default function TopContainer({ children }: Props) {
  return <div className={style.container}>{children}</div>;
}
